import { render, staticRenderFns } from "./ReportTag.vue?vue&type=template&id=59c6dc98&scoped=true"
import script from "./ReportTag.vue?vue&type=script&lang=js"
export * from "./ReportTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6dc98",
  null
  
)

export default component.exports